import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const initializeEnrollmentContract = createApiThunk<string, string>(
  "educationalAdvisor/initializeEnrollmentContract",
  async (enrollmentId, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.initializeEnrollmentContract(enrollmentId);
  },
);

export const resetInitializeEnrollmentContract = createAction("educationalAdvisor/resetInitializeEnrollmentContract");
